var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    this.tag,
    { tag: "component" },
    [
      _vm.show
        ? _c("img", {
            attrs: {
              src: "/static/images/flags/" + _vm.flagLang,
              alt: _vm.parsedLang,
              title: _vm.parsedLang
            },
            on: { error: _vm.imgError }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.value
        ? _c("span", [_vm._v("\n    " + _vm._s(_vm.value) + "\n  ")])
        : _vm._e(),
      _vm._v(" "),
      _vm._t("default")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a46d3362", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a46d3362","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LangString.vue
// module id = null
// module chunks = 